<div class="page-container">
  <div class="page-content">
    <div class="panel panel-default shadow" style="border: none">
      <div class="panel-body delete-confirm-body">
        <div *ngIf="loading" class="delete-confirm-loading">
          <i class="icon-spinner2 spinner"></i>
        </div>
        <div *ngIf="!loading">
          <h4 *ngIf="title" id="deleteConfirmTitle" class="delete-confirm-title">{{title}}</h4>
          <p id="deleteConfirmBody" class="delete-confirm-text" [innerHTML]="body"></p>
          <p *ngIf="abortNote" class="delete-confirm-text">{{abortNote}}</p>
          <p *ngIf="supportNote" class="delete-confirm-text text-muted">{{supportNote}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
